/**
 * I passi del tutorial guidato di Incoming/Outcoming > Dettaglio.
 *
 * Nessun preparativo: la pagina non ha menu ne' dialog da aprire, quindi non
 * serve nemmeno un `onStop` che la rimetta a posto.
 *
 * Tutto quello che sta sotto il campo del lettore compare solo dopo una lettura
 * andata a buon fine. Finche' non si e' scansionato nulla quei passi si
 * agganciano in basso e raccontano lo stesso cosa ci si trovera'.
 */
const at = name => `[data-tour-scope="warehouse-detail"] [data-tour="${name}"]`;

export function createWarehouseDetailTourSteps() {
	return [
		{
			body: "Delle sei voci di questo menu, questa e' l'unica che non tocca niente: si passa un codice sotto il lettore e si vede cos'e' e quanti pezzi ce ne sono. Nessun carico, nessuno scarico, nessun conteggio salvato. Serve al banco, quando hai in mano una scatola e vuoi solo sapere cosa contiene e com'e' messa a magazzino.",
			key: 'intro',
			placement: 'bottom',
			target: at('tutorial'),
			title: 'La voce che guarda e basta',
		},
		{
			body: "Non c'e' niente da cliccare prima di leggere: la pagina ascolta la tastiera per intero, e un lettore barcode per il computer non e' altro che una tastiera che digita in fretta e preme Invio alla fine. Punta e spara, il codice arriva da solo. Il campo e' in sola lettura apposta - ci compare l'ultimo codice letto, ma non si scrive a mano.",
			key: 'scan',
			placement: 'bottom',
			target: at('scan'),
			title: 'Come si legge un codice',
		},
		{
			body: "Se la pistola non c'e' o il computer e' lontano, il telefono fa da lettore: premi LEGGI CON IL TELEFONO, inquadra il QR che compare e sul telefono si apre la fotocamera - niente app da installare. Legge EAN-13 ed EAN-8, UPC, Code128, Code39, QR e DataMatrix. Ogni codice va confermato con INVIA sul telefono, cosi' un doppio scatto non passa inosservato. Il collegamento resta attivo anche passando alle altre pagine del magazzino, finche' non premi DISCONNETTI. Il codice inviato fa esattamente quello che fa la pistola: apre il dettaglio del prodotto.",
			key: 'phone',
			placement: 'bottom',
			target: at('phone'),
			title: 'Leggere con il telefono',
		},
		{
			body: "Sopra al risultato compare la mappa delle varianti del prodotto: la griglia di tutte le combinazioni - taglia per colore, per dire - con quelle esistenti evidenziate. Serve a vedere in un colpo d'occhio il quadro intero dell'articolo, non solo la variante che hai in mano.",
			key: 'map',
			placement: 'bottom',
			target: at('map'),
			timeout: 250,
			title: 'La mappa delle varianti',
		},
		{
			body: "La riga del risultato: foto, nome, sku ed ean della variante letta, le sue caratteristiche in etichette colorate e, in fondo, la quantita' a magazzino. Se il codice non corrisponde a nulla, al posto della tabella compare un avviso rosso - vuol dire che quell'ean o quello sku non e' su nessun prodotto del catalogo.",
			key: 'table',
			placement: 'top',
			target: at('table'),
			timeout: 250,
			title: 'Cosa ti dice il risultato',
		},
	];
}
